// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import TheContainer from './the-container'
import router from './router'
import store from './store'
import bus from './plugins/event-bus'
import VueSweetAlert from 'vue-sweetalert'
import VeeValidate from 'vee-validate'
import Inputmask from 'inputmask'
import VueClip from 'vue-clip'
import Paginate from 'vuejs-paginate'
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Multiselect from 'vue-multiselect'

Vue.component('paginate', Paginate)
Vue.component('multiselect', Multiselect)
Vue.config.productionTip = false

Vue.use(bus)
Vue.use(VueSweetAlert)
Vue.use(VeeValidate)
Vue.use(VueClip)
Vue.use(VueQuillEditor)

Vue.directive('mask', {
  bind: function (el, binding) {
    var im = new Inputmask(binding.value, {jitMasking: true, showMaskOnHover: false, greedy: false})
    im.mask($(el))
  }
})

Vue.directive('valor', {
  bind: function (el, binding) {
    var im = new Inputmask('currency', {
      showMaskOnHover: false,
      greedy: false,
      prefix: '',
      digits: 2,
      DecimalProtect: false,
      groupSize: 255
    })
    im.mask($(el))
  }
})

Vue.directive('time', {
  bind: function (el, binding) {
    var im = new Inputmask('99:99', {
      showMaskOnHover: false,
      greedy: false,
      prefix: ''
    })
    im.mask($(el))
  }
})

window.$ = window.jQuery = require('jquery')
require('materialize-css')

Vue.filter('slugable', function (value) {
  value = value.toLowerCase()
  value = value.replace(/[á|ã|â|à]/gi, 'a')
  value = value.replace(/[é|ê|è]/gi, 'e')
  value = value.replace(/[í|ì|î]/gi, 'i')
  value = value.replace(/[õ|ò|ó|ô]/gi, 'o')
  value = value.replace(/[ú|ù|û]/gi, 'u')
  value = value.replace(/[ç]/gi, 'c')
  value = value.replace(/[ñ]/gi, 'n')
  value = value.replace(/[á|ã|â]/gi, 'a')
  value = value.replace(/\W/gi, '-')
  value = value.replace(/\1+/gi, '-')
  return value
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<the-container/>',
  components: {TheContainer}
})



// WEBPACK FOOTER //
// ./src/main.js